/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * config.js
 */

export default class Config {
    static OAUTH_API_URL: string = process.env.REACT_APP_OAUTH_HOST || ""
    static API_URL: string = process.env.REACT_APP_API_HOST || ""
    static OAUTH_REDIRECT_URI: string = process.env.REACT_APP_OAUTH_REDIRECT_URI || ""
    static API_CLIENT_ID: string = process.env.REACT_APP_CLIENT_ID || ""
    static API_CLIENT_SECRET: string = process.env.REACT_APP_CLIENT_SECRET || ""
}

/*
//  * Copyright (c) Hilo 2020.
//  * Author: fharold
//  *
//  * hilo-oauth-manager
//  * config.ts
//  */

// export default {
//     OAUTH_API_URL: "http://localhost:5588",
//     API_URL: "http://localhost:5588",
//     OAUTH_REDIRECT_URI: "https://account.kalaora.fr",
//     API_CLIENT_ID: "5ef0740854788f13f2131d4c",
//     API_CLIENT_SECRET: "VOFiTvmvFjenDJS4To1wTmnI0MMFqdNUPmo0hpWExE5UJAalC15lUyAFCv0Cqfqt"
// }